import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { connect } from 'react-redux';

// Style
import cx from 'classnames';
import {
  Button,
  Row,
  FormGroup,
  Col,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FooterBlockForm.css';
import cs from '../../../components/commonStyle.css';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../MultiLanguageInput';

class FooterBlockForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };

  handleFieldChange = (fieldName, value) => {
    const { dispatch } = this.props;
    dispatch(change('FooterBlockForm', fieldName, value));
  };

  render() {
    const { error, handleSubmit, submitting, dispatch, initialValues, title, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.pagecontentWrapper)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
            <h1 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.spaceBottom12)}><FormattedMessage {...messages.footerBlockLabel} /></h1>
            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{formatMessage(error)}</strong>}
              
              {/* Title 1 - Multi-language */}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.adminTitleLabel} /> 1</label>
                <MultiLanguageInput
                  baseField="title1"
                  values={formValues}
                  onChange={this.handleFieldChange}
                  inputType="text"
                  placeholder={formatMessage(messages.title1)}
                />
              </FormGroup>

              {/* Content 1 - Multi-language */}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.contentLabel} /> 1</label>
                <MultiLanguageInput
                  baseField="content1"
                  values={formValues}
                  onChange={this.handleFieldChange}
                  inputType="textarea"
                  placeholder={formatMessage(messages.footerContent1)}
                />
              </FormGroup>

              {/* Title 2 - Multi-language */}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.adminTitleLabel} /> 2</label>
                <MultiLanguageInput
                  baseField="title2"
                  values={formValues}
                  onChange={this.handleFieldChange}
                  inputType="text"
                  placeholder={formatMessage(messages.title2)}
                />
              </FormGroup>

              {/* Content 2 - Multi-language */}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.contentLabel} /> 2</label>
                <MultiLanguageInput
                  baseField="content2"
                  values={formValues}
                  onChange={this.handleFieldChange}
                  inputType="textarea"
                  placeholder={formatMessage(messages.footerContent2)}
                />
              </FormGroup>

              {/* Title 3 - Multi-language */}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.adminTitleLabel} /> 3</label>
                <MultiLanguageInput
                  baseField="title3"
                  values={formValues}
                  onChange={this.handleFieldChange}
                  inputType="text"
                  placeholder={formatMessage(messages.title3)}
                />
              </FormGroup>

              {/* Content 3 - Multi-language */}
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.contentLabel} /> 3</label>
                <MultiLanguageInput
                  baseField="content3"
                  values={formValues}
                  onChange={this.handleFieldChange}
                  inputType="textarea"
                  placeholder={formatMessage(messages.footerContent3)}
                />
              </FormGroup>

              <FormGroup className={s.noMargin}>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                    <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                      <FormattedMessage {...messages.save} />
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </div>
        </div>
      </div>
    );
  }

}

FooterBlockForm = reduxForm({
  form: 'FooterBlockForm', // a unique name for this form
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(FooterBlockForm);

const selector = formValueSelector('FooterBlockForm');

// Helper to generate field selectors for all languages
const getMultiLangFields = (state, baseFields) => {
  const result = {};
  const langs = ['', '_en', '_fr', '_it', '_pt'];
  baseFields.forEach(field => {
    langs.forEach(lang => {
      const fieldName = `${field}${lang}`;
      result[fieldName] = selector(state, fieldName);
    });
  });
  return result;
};

const mapState = (state) => ({
  formValues: getMultiLangFields(state, ['title1', 'content1', 'title2', 'content2', 'title3', 'content3'])
});

const mapDispatch = { change };

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(FooterBlockForm)));